import React, { useState } from 'react';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { trackEvent } from './firebaseAnalytics';

function ContactPageContent() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState({ state: 'idle', message: '' });
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setForm({ ...form, [id]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!executeRecaptcha) {
      setStatus({ state: 'error', message: 'reCAPTCHA has not loaded yet. Please try again.' });
      return;
    }

    const { name, email, subject, message } = form;
    setStatus({ state: 'loading', message: '' });

    trackEvent('contact_click', {
      source: 'contact_form',
      method: 'api',
    });

    try {
      const recaptchaToken = await executeRecaptcha('contact_submit');
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000';
      const response = await fetch(`${backendUrl}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ name, email, subject, message, recaptchaToken })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      setStatus({ state: 'success', message: 'Your message has been sent successfully. We will get back to you soon!' });
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      console.error('Error sending message:', error);
      setStatus({ state: 'error', message: 'Failed to send message. Please try again later.' });
    }
  };

  return (
    <div>
      <style>{`.grecaptcha-badge { visibility: hidden !important; }`}</style>
      <div className="container" style={{ paddingTop: 0 }}>
        <section id="contact" className="section" data-bg="indigo">
          <div style={{ textAlign: 'center', marginBottom: 22 }}>
            <span className="badge">
              <i className="fi fi-rr-envelope" style={{ fontSize: 14, opacity: .9 }}></i> CONTACT
            </span>
            <h1 style={{ fontSize: 'clamp(28px,4vw,46px)', margin: '10px 0' }}>Contact Promptera</h1>
            <p className="subtitle" style={{ marginTop: 0 }}>Have questions or need help? We’re here for you</p>
          </div>

          <div style={{ maxWidth: 600, margin: '0 auto' }}>
            <form className="card glass contact-us-form" onSubmit={handleSubmit}>
              <div className="shine"></div>
              <h3>We’d love to help! Let us know how</h3>
              <div style={{ height: 24 }}></div>

              <label className="label" htmlFor="name">Full Name</label>
              <input
                className="input"
                id="name"
                placeholder="First and last name"
                value={form.name}
                onChange={handleChange}
                required
              />

              <div style={{ height: 20 }}></div>
              <label className="label" htmlFor="email">Email Address</label>
              <input
                className="input"
                id="email"
                type="email"
                placeholder="you@example.com"
                value={form.email}
                onChange={handleChange}
                required
              />

              <div style={{ height: 20 }}></div>
              <label className="label" htmlFor="subject">Subject Of Interest</label>
              <input
                className="input"
                id="subject"
                placeholder="Regarding Product"
                value={form.subject}
                onChange={handleChange}
                required
              />

              <div style={{ height: 20 }}></div>
              <label className="label" htmlFor="message">How may we assist you?</label>
              <textarea
                id="message"
                className="input"
                rows={5}
                placeholder="Give us more info.."
                value={form.message}
                onChange={handleChange}
              ></textarea>

              <div style={{ height: 20 }}></div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px', marginTop: '20px', flexWrap: 'wrap-reverse' }}>
                <div style={{ 
                  flex: 1,
                  padding: '12px', 
                  background: 'transparent', 
                  border: 'none',
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '12px',
                  fontSize: '0.75rem', 
                  color: 'var(--muted)', 
                  lineHeight: '1.4',
                  textAlign: 'left',
                  minWidth: '250px'
                }}>
                  <i className="fi fi-rr-shield-check" style={{ fontSize: '20px', color: 'var(--accent)', opacity: 0.8 }}></i>
                  <div>
                    Protected by Google reCAPTCHA. <br/>
                    <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>Terms of Service</a> apply.
                  </div>
                </div>
                
                <button className="btn btn-card" type="submit" disabled={status.state === 'loading'} style={{ flexShrink: 0 }}>
                  {status.state === 'loading' ? 'Sending...' : 'Send Your Message'}
                </button>
              </div>

              {status.state === 'success' && (
                <div style={{ marginTop: 20, color: 'var(--accent)', fontWeight: 'bold' }}>
                  {status.message}
                </div>
              )}
              {status.state === 'error' && (
                <div style={{ marginTop: 20, color: 'red', fontWeight: 'bold' }}>
                  {status.message}
                </div>
              )}
            </form>
          </div>
        </section>
      </div>
    </div>
  );
}

export default function ContactPage() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
      <ContactPageContent />
    </GoogleReCaptchaProvider>
  );
}
